const LeftSubSection = ({
  title,
  styleClass,
  children,
}: {
  title?: React.ReactNode;
  styleClass?: string;
  children: React.ReactNode;
}) => (
  <div
    className={`card-shadow flex flex-col px-[30px] py-[25px] gap-y-[35px] border border-[#CECECE] border-[0.5px] ${styleClass}`}
    style={{ borderRadius: 10 }}
  >
    {title && (
      <div className="text-[18px] text-[#0A0A0A] pb-[8px] border-b border-[#eeeeee]">
        {title}
      </div>
    )}
    {children}
  </div>
);

export default LeftSubSection;
